// extracted by css-extract-rspack-plugin
export default {"runQueryButton":"FlOpquadsVoKuR39"};